import * as React from "react";
const SvgMastercard = (props) => /* @__PURE__ */ React.createElement("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 152.4 108",
	style: { enableBackground: "new 0 0 152.4 108" },
	xmlSpace: "preserve",
	...props
}, /* @__PURE__ */ React.createElement("style", { type: "text/css" }, "\n	.st0{fill:none;}\n	.st1{fill:#FF5F00;}\n	.st2{fill:#EB001B;}\n	.st3{fill:#F79E1B;}\n"), /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", {
	y: 0,
	className: "st0",
	width: 152.4,
	height: 108
}), /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", {
	x: 60.4,
	y: 25.7,
	className: "st1",
	width: 31.5,
	height: 56.6
}), /* @__PURE__ */ React.createElement("path", {
	className: "st2",
	d: "M62.4,54c0-11,5.1-21.5,13.7-28.3c-15.6-12.3-38.3-9.6-50.6,6.1C13.3,47.4,16,70,31.7,82.3 c13.1,10.3,31.4,10.3,44.5,0C67.5,75.5,62.4,65,62.4,54z"
}), /* @__PURE__ */ React.createElement("path", {
	className: "st3",
	d: "M134.4,54c0,19.9-16.1,36-36,36c-8.1,0-15.9-2.7-22.2-7.7c15.6-12.3,18.3-34.9,6-50.6c-1.8-2.2-3.8-4.3-6-6 c15.6-12.3,38.3-9.6,50.5,6.1C131.7,38.1,134.4,45.9,134.4,54z"
}))));
export default SvgMastercard;
